// SPDX-License-Identifier: BUSL-1.1

/**
 * Jobs tab for the agent-detail page.
 *
 * Extracted from `routes/agent-detail.tsx` during the P3b refactor.
 */

import { DataTable } from '@/components/data-table';
import { jobColumns } from './job-columns';
import type { Job } from './types';

export function JobsTab({
  jobData,
  onJobClick,
}: {
  jobData: Job[];
  onJobClick: (job: Job) => void;
}) {
  return (
    <DataTable
      columns={jobColumns}
      data={jobData}
      emptyMessage="No jobs found for this agent."
      onRowClick={onJobClick}
    />
  );
}
